import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getDataPC_PaginatedV2 = (
    page,
    limit,
    sortBy,
    sortOrder,
    user_id,
    search,
    search_status,
    datefrom,
    dateto
) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.API_PETTYCASH_H}` + `/getsql-pagination-v2/${user_id}`,
        {
            params: {
                page,
                limit,
                sortBy,
                sortOrder,
                search,
                search_status,
                datefrom,
                dateto,
            },
        }
    );
};

export const billing_expense_createPC = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_H}` + `/create`, data);
};

export const billing_expense_getDataPCByIDSql = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_H}` + `/getbyid-sql/${id}`);
};

export const billing_expense_updatePCH = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_H}` + `/update/${id}`, data);
};

export const billing_expense_getDataPCApporver_PaginatedV2 = (
    page,
    limit,
    sortBy,
    sortOrder,
    user_id,
    search,
    search_status,
    datefrom,
    dateto
) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.API_PETTYCASH_H}` + `/getsql-approver-pagination-v2/${user_id}`,
        {
            params: {
                page,
                limit,
                sortBy,
                sortOrder,
                search,
                search_status,
                datefrom,
                dateto,
            },
        }
    );
};

export const billing_expense_getDataPCAccount = (user_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_H}` + `/getsql-account/${user_id}`);
};